module.exports = __webpack_public_path__ + "img/pr-36.a720b05c.png";